import { useI18n } from 'vue-i18n'

/**
 * Texto del tooltip de un mensaje que Meta no entregó: código, motivo de Meta y,
 * si el código es de los comunes, su explicación en español (`whatsapp.failure_hints`).
 */
export const useMessageFailureText = () => {
  const { t, te } = useI18n()

  const hintFor = (code?: string | null): string | null => {
    const key = `whatsapp.failure_hints.${code}`
    return code && te(key) ? t(key) : null
  }

  /** Código, motivo y explicación, uno por línea; '' si no hay nada que mostrar. */
  const describe = (code?: string | null, reason?: string | null): string =>
    [code ? `${t('whatsapp.failure_code')}: ${code}` : '', reason ?? '', hintFor(code) ?? '']
      .filter(Boolean)
      .join('\n')

  return { describe, hintFor }
}
